/* eslint-disable prefer-destructuring */
import _ from "lodash";
import { toast } from "react-toastify";
import { call, fork, put, select, spawn } from "redux-saga/effects";
import { gateway } from "../../utils/api";
import { toastErrorAndWarningOptions } from '../../utils/functions';
import history from "../../utils/history";
import { Creators as CourseActions } from "../ducks/newCourse/actions";

function getObjectContent(response, crCode) {
  let selected = null;
  let defaultSelectedCourse = 0;
  if (response.children.length > 0 && crCode) {
    if (response.type === 'TRAIL') {
      // Para trilhas: TRAIL -> COURSE -> UC -> OBJECT
      // Buscar o objeto específico pelo crCode
      for (let courseIndex = 0; courseIndex < response.children.length; courseIndex++) {
        const course = response.children[courseIndex];
        if (course.children && course.children.length > 0) {
          // Buscar em todas as UCs do curso
          for (let ucIndex = 0; ucIndex < course.children.length; ucIndex++) {
            const uc = course.children[ucIndex];
            if (uc.children && uc.children.length > 0) {
              const foundObject = uc.children.find(object => object.code === crCode);
              if (foundObject) {
                selected = foundObject;
                defaultSelectedCourse = courseIndex;
                break; // Para na primeira ocorrência encontrada
              }
            }
          }
          if (selected) break; // Se encontrou o objeto, para de buscar nos outros cursos
        }
      }
      
      // Se não encontrou o objeto específico, usar fallback: primeiro objeto da primeira UC do primeiro curso
      if (!selected) {
        for (let courseIndex = 0; courseIndex < response.children.length; courseIndex++) {
          const course = response.children[courseIndex];
          if (course.children && course.children.length > 0) {
            // Buscar a primeira UC que tenha objetos
            for (let ucIndex = 0; ucIndex < course.children.length; ucIndex++) {
              const uc = course.children[ucIndex];
              if (uc.children && uc.children.length > 0) {
                const firstObject = uc.children.find((item) => item.type === 'OBJECT');
                if (firstObject) {
                  selected = firstObject;
                  defaultSelectedCourse = courseIndex;
                  break;
                }
              }
            }
            if (selected) break;
          }
        }
      }
    } else {
      response.children.forEach(element => {
        if (element.children.length > 0) {
          element.children.find(childrenEl => {
            if (childrenEl.code === crCode) {
              selected = childrenEl;
            }
          });
        } else if (!selected) {
          selected = response.children[0];
        }
      });
    }

  } else if (response.children.length && !crCode) {
    if (response.type === 'TRAIL') {
      // Para trilhas: TRAIL -> COURSE -> UC -> OBJECT
      // Primeiro verificar se existe um item "Sobre" da trilha
      const aboutTrail = _.get(response, 'about.0', null);
      if (aboutTrail) {
        selected = {
          ...aboutTrail,
          type: "ABOUT"
        };
        defaultSelectedCourse = 0;
      } else {
        // Se não houver "Sobre", buscar o primeiro objeto do primeiro curso -> primeira UC -> primeiro objeto
        for (let courseIndex = 0; courseIndex < response.children.length; courseIndex++) {
          const course = response.children[courseIndex];
          if (course.children && course.children.length > 0) {
            // Buscar a primeira UC que tenha objetos
            for (let ucIndex = 0; ucIndex < course.children.length; ucIndex++) {
              const uc = course.children[ucIndex];
              if (uc.children && uc.children.length > 0) {
                const firstObject = uc.children.find((item) => item.type === 'OBJECT');
                if (firstObject) {
                  selected = firstObject;
                  defaultSelectedCourse = courseIndex;
                  break;
                }
              }
            }
            if (selected) break;
          }
        }
      }
    } else {
      // Para cursos: COURSE -> UC -> OBJECT
      // Buscar o primeiro objeto da primeira UC que tenha objetos
      for (let i = 0; i < response.children.length; i++) {
        const element = response.children[i];
        
        const isAbout = element.tags && element.tags.some((item) => item === 'ABOUT');
        
        if (isAbout) {
          selected = element;
          break; // Para na primeira UC "ABOUT" encontrada
        } else if (element.children && element.children.length > 0) {
          const firstObject = element.children.find((item) => item.type === 'OBJECT');
          if (firstObject) {
            selected = firstObject;
            break; // Para na primeira UC com objetos encontrada
          }
        }
      }
    }
  }
  return {
    selected,
    defaultSelectedCourse
  };
}

function* courseProgress(response, idProfile, courseAccessed, courseSession) {
  try {
    let { code, courseCode, name, gradeAverage, courseGradeStatus, id } = response

    if (!courseCode) {
      courseCode = code;
    }
    const data = {
      id,
      courseCode,
      name,
      gradeAverage,
      courseGradeStatus,
      idProfile,
      courseSession
    }

    if (!courseAccessed) {
      try {
        yield call(gateway.post, '/webbff/lit_app_web/course_progress', data);
        localStorage.setItem('courseAccessed', true)
      } catch (error) {
        console.log('Route course_progress not accessed', error);
      }
    }
  } catch (error) {
    console.log('Erro function courseProgress', error);
  }
}

function* getSessionCourse(course, idProfile, courseAccessed) {
  let { code, courseCode } = course

  if (!courseCode) {
    courseCode = code
  }

  let session;

  const sessionStorage = localStorage.getItem('session')

  if (!sessionStorage) {
    const response = yield call(gateway.get, `/webbff/lit_app_web/course_progress/course_session/${courseCode}`);

    const { maxSession } = response;

    if (!maxSession) {
      session = 1;
      localStorage.setItem('session', 1);
    } else {
      session = maxSession + 1;
    }

    localStorage.setItem('session', session);

    yield put(CourseActions.setCourseSession(session));
    yield call(courseProgress, course, idProfile, courseAccessed, session);
  } else {
    session = sessionStorage;
    yield put(CourseActions.setCourseSession(session));
    yield call(courseProgress, course, idProfile, courseAccessed, session);
  }
}

function* fetchCourse(action) {
  const { course, refreshCourse } = action.payload; 
  const idCourse = course.id;
  const courseAccessed = localStorage.getItem("courseAccessed");

  try {
    if (!courseAccessed) {
      yield spawn(function* logAccess() {
        try {
          yield call(gateway.post, '/applicationlogs/courseaccesslogs/', { courseCode: idCourse });
          localStorage.setItem('courseAccessed', true);
        } catch (error) {
          console.log('Route not accessed', error);
        }
      });
    }

    const courseObject = _.get(history, "location.state.object", null);
    let selectedObject = null;
    let defaultSelectedCourse = 0;

    if (courseObject) {
      const { selected, defaultSelectedCourse: selectedCourse } = getObjectContent(course, courseObject);
      selectedObject = selected;
      defaultSelectedCourse = selectedCourse;
    } else {
      const { selected, defaultSelectedCourse: selectedCourse } = getObjectContent(course, course.lastDispatchedContentCode);
      selectedObject = selected;
      defaultSelectedCourse = selectedCourse;
    }

    if (!selectedObject) {
      selectedObject = course.children.find(item => _.get(item, "tags", []).includes("ABOUT")) || course.children[0];
    }
    yield put(CourseActions.getCourseSuccess(course));
    yield put(CourseActions.setCourseSelected(selectedObject));
    yield put(CourseActions.setRefreshCourse(false));
    yield put(CourseActions.setDefaulfSelectedCourse(defaultSelectedCourse));

    const openProgress = localStorage.getItem('openProgress');
    if (refreshCourse || openProgress) {
      yield put(CourseActions.setCourseToShowProgress(course));
    }

    const idProfile = localStorage.getItem("idProfile");
    yield call(getSessionCourse, course, idProfile, courseAccessed);

  } catch (err) {
    console.error("Erro ao processar curso:", err);
    if (err.response) {
      err.response = {
        ...err.response,
        data: {
          message: err.response.data.message || err.response.data.error,
          ...err.response.data
        }
      };
      if (err.response.status === 401) {
        toast.warn(err.response.data.message, toastErrorAndWarningOptions);
        history.push("/");
        return;
      }
      yield put(CourseActions.getCourseFailure(err.response));
    }
  }
}


export function* getCourse(action) {
  yield fork(fetchCourse, action);
}

export function* reloadCourse(action) {
  const { idCourse } = action.payload;

  try {
    const response = yield call(
      gateway.get,
      `/webbff/lit_app_web/course/${idCourse}`
    );

    yield put(CourseActions.getCourseSuccess(response));
  } catch (err) {
    if (("ERRRO NO GET DE CURSOS", err.response)) {
      err.response = {
        ...err.response,
        data: {
          message: err.response.data.message || err.response.data.error,
          ...err.response.data
        }
      };
      if (err.response.status === 401) {
        toast.warn(err.response.data.message, toastErrorAndWarningOptions);
        history.push("/");
        return;
      }
      yield put(CourseActions.getCourseFailure(err.response));
    }
  }
}


export function* syncUserGradeByDiscipline({ payload }) {
  try {
    const state = yield select();
    const discipline = state.course.data.disciplines.find(
      item => item.idDiscipline === payload
    );
    if (!discipline.synchronized) {
      yield put(CourseActions.defineDisciplineAsSynchronizedAction(payload));
    }
  } catch (error) {
    yield put(CourseActions.defineDisciplineAsSynchronizedAction(payload));
  }
}

export function* getCourseCertificate({ payload }) {
  try {
    const courseCode = _.get(payload, 'courseCode');
    const response = yield call(
      gateway.get,
      `webbff/lit_app_web/course/${courseCode}/certificate`
    );

    yield put(CourseActions.getCourseCertificateSuccess({
      courseCode,
      response
    }));

  } catch (error) {
    yield put(CourseActions.getCourseCertificateFailure());
  }
}

